import SyntaxError from '.SyntaxError';

import * as options from './options';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import QualifiedRule from './QualifiedRule';

export default class KeyframesRule extends Layer                {
	
	get [Symbol.toStringTag] () { return 'KeyframesRule'; }
	
	                 keywordLiteral        ;
	_nameLiteral         = '';
	get nameLiteral () { return this._nameLiteral; }
	set nameLiteral (value) {
		if ( TOKEN.notKeyframes(value) ) { throw SyntaxError(`“${value}”无法作为 @keyframes 名`); }
		this._nameLiteral = value;
	}
	        _blocking          = false;
	get block () { return true; }
	
	constructor (keywordLiteral         ) {
		super();
		TOKEN.currentLayer && ( TOKEN.collection_keyframes[TOKEN.collection_keyframes.length] = this );
		this.keywordLiteral = keywordLiteral || 'keyframes';
		return this;
	}
	
	[TOKEN.consume] (                   ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
			case TOKEN.comment:
				return this;
			case TOKEN.ident:
				if ( this._blocking ) {
					TOKEN.stay();
					return this.newItem = new QualifiedRule;
				}
				else {
					if ( this._nameLiteral ) { break; }
					this.nameLiteral = TOKEN.literal;
					return this;
				}
			case TOKEN.string:
				if ( this._nameLiteral ) { break; }
				this.nameLiteral = TOKEN.literal;
				return this;
			case '{':
				if ( !this._nameLiteral || this._blocking ) { break; }
				this._blocking = true;
				return this;
			case '}':
				if ( !this._blocking ) { break; }
				return this[TOKEN.parent];
			case TOKEN.percentage:
				if ( !this._blocking ) { break; }
				TOKEN.stay();
				return this.newItem = new QualifiedRule;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                   ) {
		const { _nameLiteral } = this;
		return `@${this.keywordLiteral}${_nameLiteral[0]==='"' || _nameLiteral[0]==='\'' ? '' : ' '}${_nameLiteral}{${this.join('')}}`;
	}
	
	* [Symbol.iterator] (                   )                                {
		const { length } = this;
		if ( length ) {
			yield `@${this.keywordLiteral} ${this._nameLiteral} {`;
			let index = 0;
			while ( index!==length ) {
				for ( const line of this[index++]  ) {
					yield options.indent + line;
				}
			}
			yield `}`;
		}
		else { yield `@${this.keywordLiteral} ${this._nameLiteral} { }`; }
	}
	
	static default = protect(this);
	
};
